module.exports = __webpack_public_path__ + "static/media/Pokana_OSA_Formoplast_GFO 2017_22.05.2018.4035cfce.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2018/Pokana_OSA_Formoplast_GFO 2017_22.05.2018.pdf
// module id = 135
// module chunks = 0